import type { BannerEntity, ORD } from 'api/types';
import { useCallback, useEffect, useState } from 'react';

export const useTargetUrl = (content: BannerEntity, ord?: ORD): string => {
  const [targetUrl, setTargetUrl] = useState('');

  const getTargetUrlWithErid = useCallback(() => {
    let resultUrl;

    try {
      resultUrl = new URL(content.targetUrl);

      if (ord?.eridToken) {
        resultUrl.searchParams.set('erid', ord.eridToken);
      }
    } catch (e) {
      resultUrl = content.targetUrl;
    }

    return resultUrl.toString();
  }, [content.targetUrl, ord?.eridToken]);

  const getFormattedTargetUrl = useCallback(() => {
    let { pathname, search } = new URL(getTargetUrlWithErid());

    const userOrigin = window.location.origin;

    return `${userOrigin}${pathname}${search}`;
  }, [getTargetUrlWithErid]);

  useEffect(() => {
    setTargetUrl(getFormattedTargetUrl());
  }, [getFormattedTargetUrl]);

  return targetUrl;
};
